import React, { useState, useEffect, useCallback } from 'react'
import { DivTag } from '../../../Components/Tags/Tags'
import Header from '../../../Components/Header'
import Seo from '../../../Components/SeoComponent/Seo'
import { HeadTag, InputField } from '../../../Components/Tags/Tags'
import { showSuccessToast, showErrorToast } from '../../../utils/toastUtils'
import GaugeChart from 'react-gauge-chart'
import { checkExperianCreditReport } from '../../../Services/EquifaxCScore/highmark'
import ExperianScoreReportModals from './ExperianScoreReport'
import html2pdf from 'html2pdf.js';
import { ExperianData, equifaxDataError } from './data'
import Loader from '../../../Loader'
import { fetchProfile } from '../../../Services/profile/profileservice'

const ExperianScore = () => {

  const [cusName, setCusName] = useState();
  const [Gender, setGender] = useState('');
  const [mobile, setMobile] = useState('');
  const [panNo, setPanNo] = useState('');
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [creditScore, setCreditScore] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const [profileData, setProfileData] = useState([]);
  const [ExperianReport, setExperianReport] = useState(null);
  const [Equifaxv2Error, setEquifaxv2Error] = useState(null);
  const [submittedName, setSubmittedName] = useState('');
  const [showLoader, setShowLoader] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const maxScore = 900;

  const validateForm = () => {
    const newErrors = {};

    // Validate customer name
    if (!cusName) {
      newErrors.cusName = 'Customer name is required.';
    }

    if (!Gender) {  
      newErrors.Gender = 'Gender is required.'; 
    }


    if (mobile === "") {
      newErrors.mobile = 'Mobile number is required.';
    } else if (!/^[6-9]\d{9}$/.test(mobile)) {
      newErrors.mobile = 'Enter a valid 10-digit mobile number.';
    }



    if (panNo === "") {
      newErrors.panNo = 'PAN number is required.';
    } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panNo.toUpperCase())) {
      newErrors.panNo = 'Enter a valid PAN number (e.g., ABCDE1234F).';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handlesubmit = async () => {
    try {
      // Validate the form first
      const isValid = validateForm();
      if (!isValid) {
        setExperianReport(null);
        showErrorToast('Please correct the form errors.');
        return; // Exit if validation fails
      }
      // Call the AddEquifax function to submit data
      setShowLoader(true);
      await AddHighmark();

      setTimeout(() => {
        // Hide the loader after 1 second
        setShowLoader(false);
      }, 2000);
    } catch (error) {
      console.error('Error submitting data:', error);
      showErrorToast('Validate the Required Field');
      setShowLoader(false); // Hide loader in case of error
    }
  };


  const handleDownloadPDF = () => {
    setIsDownloading(true);
    setTimeout(() => {
      const element = document.getElementById("CreditReports");

      const name =  ExperianReport?.name || Equifaxv2Error?.data?.name || Equifaxv2Error?.error?.name || "N/A" ;

      if (element) {
        element.classList.remove('hidden');
        const clonedElement = element.cloneNode(true);
        clonedElement.style.maxHeight = 'none';
        clonedElement.style.overflow = 'visible';
        const tempDiv = document.createElement('div');
        tempDiv.style.position = 'absolute';
        tempDiv.style.visibility = 'hidden';
        tempDiv.appendChild(clonedElement);
        document.body.appendChild(tempDiv);
        html2pdf()
          .from(clonedElement)
          .set({
            margin: [0.2, 0.2, 0.2, 0.2],
            filename: `Experian_Credit_Report_${name}.pdf`,
            image: { type: 'jpeg', quality: 0.90 },
            html2canvas: { scale: 2, backgroundColor: 'white' },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
          })
          .save()
          .then(() => {
            document.body.removeChild(tempDiv);
            element.classList.add('hidden');
            setIsDownloading(false);
          })
          .catch(() => {
            showErrorToast("Failed to generate PDF");
            element.classList.add('hidden');
            setIsDownloading(false);
          });
      } else {
        showErrorToast("No data found to download");
        
      }
    }, 500);
  };


  // Add Experian Score Data
  async function AddHighmark() {
    try {
      setShowLoader(true);
      const payload = {
        "api_id": profileData?.user_id,
        "api_key": profileData?.api_key,
        "token_id": profileData?.token_id,
        "mobile": mobile,
        "pan": panNo,
        "name": cusName,
        "gender": Gender,
        "consent": "Y"
      }
      const response = await checkExperianCreditReport(payload);
      const statusCode = response?.status?.code || response?.status;
      if (statusCode === 403 && statusCode.message === "Invalid or deactivated API key.") {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Invalid or deactivated API key.");
        return
      }


      if (statusCode === 422 && statusCode.message === "Insufficient balance in wallet.") {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("Insufficient balance.");
        return
      }


      if (statusCode === 422 && statusCode.message === "User not authorized to access this service.") {
        setShowLoader(false);
        setIsLoading(false);
        showErrorToast("User not authorized to access this service.");
        return
      }


      if (statusCode === 200) {
        setIsLoading(false);
        setExperianReport(response.data);
        setCreditScore(response.data.credit_score)
        setSubmittedName(cusName);
        setCusName('');
        setMobile('');
        setPanNo('');
        setIsLoading(false);
        setShowLoader(true);
        showSuccessToast(response?.status?.message || response?.message || "Credit score fetched successfully.");
        return;
      } else {
        setEquifaxv2Error(response?.error || response?.data || {});
        setExperianReport(null);
        showErrorToast(
          response?.data?.message ||
          response?.message ||
          response?.data?.error?.credit_report_message?.message ||
          response?.data?.error ||
          "Something went wrong."
        );
      }
      return;
    } catch (error) {
      console.error("Error in Experian:", error);
      setExperianReport(null);
      setEquifaxv2Error(error);
      showErrorToast("Something went wrong.");
    } finally {
      setShowLoader(false);
      setIsLoading(false);
    }
  }
  // ENd

  useEffect(() => {
    async function fetchProfileData() {
      try {
        const response = await fetchProfile();
        setProfileData(response.data);
      } catch (error) {
        console.error('Error fetching profile data', error);
      }
    }
    fetchProfileData();
  }, []);
  // const responses = ExperianReport && ExperianReport?.credit_report.CAIS_Account.CAIS_Account_DETAILS;

  const responses = ExperianReport && ExperianReport?.credit_report?.CAIS_Account?.CAIS_Account_DETAILS;

  // Helper function to format keys for display
  const formatKey = (key) => {
    return key.replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase())
      .replace(/_/g, ' ');
  };




  function convertDateForm(time) {
    let s = `${time}`;
    return s.slice(0, 4) + "/" + s.slice(4, 6) + "/" + s.slice(6, 8);
  }



  const safeGet = (obj, path, defaultValue = "N/A") => {
    if (!obj) return defaultValue;
    return path.split('.').reduce((current, key) => {
      return current && current[key] !== undefined && current[key] !== null ? current[key] : defaultValue;
    }, obj);
  };

  // Helper function to convert date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    if (convertDateForm) return convertDateForm(dateString);
    return dateString;
  };



  return (
    <>
      <Seo />
      {showLoader && <Loader />}

      <Header heading='Experian Credit report (Experian Version1)' />
      <DivTag className="container grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-5 gap-1 md:gap-2 p-2 bg-white  md:mt-1 mt-0 shadow-blue-600 rounded-md">

        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif" >Customer Name<strong className='text-red-700'>*</strong></HeadTag>
          <input
            type='text'
            id="cus_name"
            name="cus_name"
            value={cusName}
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
            placeholder="Enter Customer Name"
            onChange={(e) => setCusName(e.target.value)}
          />
          {errors.cusName && <p className="text-red-600 text-sm font-mono">{errors.cusName}</p>}
        </DivTag>



        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif" >Mobile <strong className='text-red-700'>*</strong></HeadTag>
          <InputField
            type="text"
            placeholder="Enter Mobile"
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
            name="mobile"
            id="mobile"
            onChange={(e) => setMobile(e.target.value)}
          />
          {errors.mobile && <p className="text-red-600 text-sm font-mono">{errors.mobile}</p>}
        </DivTag>

         
         <DivTag className="flex flex-col"> 
          <HeadTag className="text-md font-serif"> Gender <strong className='text-red-700'>*</strong></HeadTag>
          <select
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
            name="gender"
            id="gender"
            onChange={(e) => setGender(e.target.value)}
          >
            <option value="">Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female </option>
            
          </select>
          {errors.Gender && <p className="text-red-600 text-sm font-mono">{errors.Gender}</p>}
        </DivTag>




        <DivTag className="flex flex-col">
          <HeadTag className="text-md font-serif"> Pan No. <strong className='text-red-700'>*</strong></HeadTag>
          <InputField
            type="text"
            placeholder="Enter Pan"
            className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600"
            name="pan_no"
            id="pan_no"
            onChange={(e) => setPanNo(e.target.value)}
          />
          {errors.panNo && <p className="text-red-600 text-sm font-mono">{errors.panNo}</p>}
        </DivTag>

        <div className="flex justify-center">
          <button
            className={`rounded-md p-1 bg-blue-700 text-white mt-2 mb-1 h-8 px-3 ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
            onClick={handlesubmit}
            disabled={isLoading}
          >
            {isLoading ? 'Submitting....' : 'Get Score'}
          </button>
        </div>

      </DivTag>

      <div className='w-full text-center'>
        {errors.identification && <p className='text-red-600 text-sm font-mono'>{errors.identification}</p>}
      </div>

      {
        ExperianReport || Equifaxv2Error ? (
          <div className="flex flex-col p-4 bg-white shadow-inner md:mt-1 shadow-blue-600 rounded-md">
            <span className='text-center font-bold md:text-xl'>
              Hey {
                // Corrected data path for name display
                ExperianReport?.name ||
                submittedName ||
                Equifaxv2Error?.data?.name ||
                Equifaxv2Error?.error?.name ||
                "User"
              }!
            </span>
            <h2 className="text-xl md:text-xl font-semibold text-center">Your Experian Credit Score</h2>

            <div className="flex flex-col md:flex-row justify-center md:justify-center gap-4 md:gap-8 md:mt-2 mt-3 relative">
              <div className="w-full md:w-[400px] relative md:mt-10">

                <span className="text-red-500 md:font-bold absolute md:top-[20px] md:left-10 md:mt-16 -rotate-70 top-[60px] left-5">Poor</span>
                <span className="text-yellow-400 md:font-bold absolute md:left-[104px] md:mt-1 -rotate-26 left-[69px] top-[-7px]">Average</span>
                <span className="text-orange-600 md:font-bold absolute md:left-60 md:mt-0 md:rotate-20 left-[12rem] mt-[-9px] rotate-20">Good</span>
                <span className="text-green-800 md:font-bold absolute md:top-[20px] md:ml-[19.5rem] md:mt-16 rotate-70 ml-[16rem] mt-[3.5rem]">Excellent</span>

                <GaugeChart
                  id="gauge-chart1"
                  nrOfLevels={3}
                  percent={creditScore / maxScore}
                  needleColor={"#00008b"}
                  textColor={"transparent"}
                  needleBaseColor={"red"}
                  arcsLength={[0.3, 0.3, 0.3, 0.3]}
                  colors={['#cc0000', '#e6e600', '#cc6600', '#009900']}
                />
                <p className="text-black font-bold text-xl md:text-2xl absolute bottom-12 md:bottom-[5.5rem] left-1/2 transform -translate-x-1/2">
                  {creditScore}
                </p>
              </div>

              <div className="flex flex-col items-center md:items-start">
                <ul className="text-left text-sm md:text-base space-y-1 mt-4">
                  {
                    // Corrected data path for Credit Account Summary
                    ExperianReport?.CAIS_Account?.CAIS_Summary?.Credit_Account &&
                    Object.entries(ExperianReport?.CAIS_Account?.CAIS_Summary?.Credit_Account).map(([key, value], i) => (
                      <li key={i}>
                        <span className="font-bold">{formatKey(key)}</span>: {value || "N/A"}
                      </li>
                    ))
                  }
                  {
                    // Corrected data path for Outstanding Balance
                    ExperianReport?.CAIS_Account?.CAIS_Summary?.Total_Outstanding_Balance &&
                    Object.entries(ExperianReport.CAIS_Account.CAIS_Summary.Total_Outstanding_Balance).map(([key, value], i) => (
                      <li key={i}>
                        <span className="font-bold">{formatKey(key)}</span>: {value || "N/A"}
                      </li>
                    ))
                  }
                </ul>

                <ExperianScoreReportModals
                  isOpen={isModalOpen}
                  onClose={() => setModalOpen(false)}
                  ExperianReport={ExperianReport}
                  Equifaxv2Error={Equifaxv2Error}
                />

                <div className="flex space-x-2 mt-4">
                  <button
                    onClick={() => setModalOpen(true)}
                    className="bg-blue-600 text-white text-sm md:text-base rounded-md px-2 py-1">
                    View Details
                  </button>
                  {/* <button
                    className="bg-red-600 text-white text-sm md:text-base rounded-md px-2 py-1"
                    onClick={handleDownloadPDF}
                    disabled={isDownloading}
                  >
                    {isDownloading ? "Downloading..." : "Download"}
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        ) : ""
      }
      <div className='flex justify-center'>
        <div class="flex flex-col items-center bg-gray-200 rounded-md shadow-lg shadow-blue-800 md:w-3/4 w-full p-1">
          <h1 class="font-bold text-2xl text-red-600 underline mb-2">Instructions</h1>
          <h2 class="text-xl font-bold text-center text-gray-800 mb-2 underline">How to get Best Financial Credit Report in Experian Version 1?</h2>
          {/* <p class="text-center text-gray-600 mb-4 font-semibold md:whitespace-nowrap ">
            Every individual or company is entitled to check their CIBIL score. Follow the steps below to get a better report:
          </p> */}
          <ul class="list-decimal list-inside text-left text-gray-700">
            <li className=''>Enter the correct customer’s full name.</li>
            <li>Enter the Mobile Number which is registered in credit bureau company.</li>
            <li>Enter the correct PAN Number.</li>
            <li>The Experian V1 credit Report only provide the detailsReport of that consumer which is available in the Experian Bureau.</li>
            <li>If you didn’t get the report means you should try with different details or in another bureau company.</li>
          </ul>
        </div>
      </div>

      <>
        <div id="CreditReports" className="hidden bg-white rounded-lg shadow-lg w-full md:max-w-3xl overflow-y-auto max-h-[100vh]">
          {/* Check if ExperianReport exists */}

          <>

            <div className="a4-page">
              <div className="grid grid-cols-1 md:grid-cols-12">
                <div className="col-span-2">
                  <img
                    src="https://www.experian.com/static/shared/logos/logo-experian.svg"
                    className="w-24 p-1"
                    alt="Experian Logo"
                  />
                </div>
                <div className="col-span-8 md:text-center text-center">
                  <h4 className="text-2xl font-bold"> Experian Credit Report</h4>
                </div>
                <div className="col-span-2 md:text-end text-end text-sm">
                  Credit Score: <strong className="text-xl">
                    {ExperianReport?.credit_score}
                  </strong>
                </div>
              </div>

              <div className="flex justify-between items-start flex-wrap">
                {/* Start section */}
                <div className="">
                  <p className='text-xs'><i>Client ID:</i> <span className="client_id">{ExperianReport && ExperianReport?.client_id}</span></p>
                  <p className='text-xs'><i>Report Order No:</i> <span className="report_order_no">{ExperianReport && ExperianReport?.credit_report?.CreditProfileHeader?.ReportNumber}</span></p>
                </div>

                {/* End section */}
                <div className="text-right">
                  <p className='xs'><i>Date:</i> <span className="report_date">{convertDateForm(ExperianReport && ExperianReport?.credit_report?.CreditProfileHeader?.ReportDate)}</span></p>


                </div>
              </div>

              <div className="flex flex-col items-center justify-center my-4">
                {Equifaxv2Error && (
                  <div className="bg-red-50 border border-red-400 rounded-md p-1 w-full md:w-3/4">
                    <p className="text-center text-red-600 font-bold">
                      Error:{" "}
                      <span className="font-normal">
                        {
                          // Case 1: credit_report_message.message_code
                          Equifaxv2Error?.error?.credit_report_message?.message
                            ?.replace(/_/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                          // Case 2: direct message
                          Equifaxv2Error?.message
                            ?.replace(/_/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                          ExperianReport?.message
                            ?.replace(/_/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                          "Unknown Error"
                        }
                      </span>
                    </p>
                    <p className="text-center text-red-600 font-bold mt-1">
                      Code:{" "}
                      <span className="font-normal">
                        {
                          // Case 1: credit_report_message.message_code
                          Equifaxv2Error?.error?.credit_report_message?.message_code
                            ?.replace(/_/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                          // Case 2: direct message_code
                          Equifaxv2Error?.message_code
                            ?.replace(/_/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                          ExperianReport?.message_code
                            ?.replace(/_/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase()) ||
                          "Unknown code"
                        }
                      </span>
                    </p>
                  </div>
                )}
              </div>

              <div className='flex justify-center'>
                <p className='font-bold text-white text-sm'>Personal Details</p>
              </div>
              <div className="border border-blue-500 p-2 rounded-md">

                <div className="grid grid-cols-2 md:grid-cols-2  gap-1">
                  {/* Consumer Name */}
                  <div>
                    <p className='text-xs'><i>Consumer Name</i><span> : {ExperianReport && ExperianReport?.name
                      || Equifaxv2Error?.data?.name ||
                      Equifaxv2Error?.error?.name
                    }</span></p>



                    {/* <p><i>Consumer Name</i><span> : {submittedName}</span></p> */}
                  </div>
                  <div>
                    {(() => {
                      const firstDOB = ExperianReport?.credit_report?.CAIS_Account?.CAIS_Account_DETAILS?.[0]?.CAIS_Holder_Details?.[0]?.Date_of_birth;
                      return (
                        <tr>
                          <td colSpan={6}>
                            <div className="mb-3">
                              <p className='text-xs'><i>D.o.b</i><span> : {firstDOB ? formatDate(firstDOB) : "N/A"}</span></p>
                            </div>
                          </td>
                        </tr>
                      );
                    })()}
                  </div>
                  {/* <div>
                <p><i>Age</i><span> : {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["REQUEST"]?.["AGE"]}</span></p>
              </div> */}
                  <div>
                    <p className='text-xs'><i>Gender</i><span> : {ExperianReport && ExperianReport?.credit_report.Current_Application?.Current_Application_Details?.Gender_Code || (Equifaxv2Error?.error?.gender) || (Equifaxv2Error?.data?.gender)}</span></p>
                  </div>
                  <div>
                    <p className='text-xs'>Mob : {ExperianReport?.mobile || Equifaxv2Error?.error?.mobile || Equifaxv2Error?.data?.mobile}</p>

                  </div>
                  <div className="">
                    <p className='text-xs'>Pan/Aadhar : {ExperianReport?.pan || Equifaxv2Error?.error?.id_number || Equifaxv2Error?.data?.id_number}</p>
                  </div>
                </div>
              </div>

              <hr className="my-2" />

              {responses?.length > 0 && (
                <div className="w-full">
                  <AccountHolderAddressDetails
                    addressDetails={responses.flatMap(
                      (LinkedAC) => LinkedAC?.CAIS_Holder_Address_Details || []
                    )}
                  />
                </div>
              )}

              {/* Accounts Section */}
              <div className=" bg-blue-900 md:text-white text-white p-1 mt-2 rounded-tr-xl rounded-tl-xl text-sm">Account Details</div>


              {/* 1st Retail */}
              <table className="min-w-full table-auto text-left mt-2 border-collapse">
                <tbody className="mb-2">

                  {/* Linked Accounts Section */}

                  {responses && Array.isArray(responses) && responses.length > 0 && (
                    <tr className="my-1">
                      <td colSpan={6} className="px-1 py-0">
                        <h2 className="font-semibold bg-blue-900 text-white p-2 rounded-tr-xl rounded-tl-xl text-sm">Linked A/c Details</h2>
                        <div className="flex flex-wrap mt-1">
                          {responses.map((LinkedAC, idx) => (
                            <div key={idx} className="w-full mb-4">
                              <div className="grid grid-cols-4 gap-2 mb-2 border p-2 text-xs">
                                <div><span className="font-semibold">Account Number:</span> {LinkedAC?.Account_Number || 'N/A'}</div>
                                <div><span className="font-semibold">Account Type:</span> {LinkedAC?.Account_Type || 'N/A'}</div>
                                <div><span className="font-semibold">Subscriber Name:</span> {LinkedAC?.Subscriber_Name || 'N/A'}</div>
                                <div><span className="font-semibold">Date Reported:</span> {formatDate(LinkedAC?.Date_Reported)}</div>
                                <div><span className="font-semibold">Date Closed:</span> {formatDate(LinkedAC?.Date_Closed)}</div>
                                <div><span className="font-semibold">Last Payment Date:</span> {formatDate(LinkedAC?.Date_of_Last_Payment)}</div>
                                <div><span className="font-semibold">Overdue Amount:</span> ₹{LinkedAC?.Amount_Past_Due || "N/A"}</div>
                                <div><span className="font-semibold">Current Balance:</span> ₹{LinkedAC?.Current_Balance || "N/A"}</div>
                              </div>

                              <PaymentHistoryLists history={LinkedAC?.CAIS_Account_History || []} />
                              <AccountHolderDetails accountHolder={LinkedAC?.CAIS_Holder_Details || []} convertDateForm={formatDate} />
                              {/* <AccountHolderAddressDetails addressDetails={LinkedAC?.CAIS_Holder_Address_Details || []} convertDateForm={formatDate} /> */}
                              <AccountHolderPhoneDetails phoneDetails={LinkedAC?.CAIS_Holder_Phone_Details || []} convertDateForm={formatDate} />
                              {/* <AccountHolderIdDetails idDetails={LinkedAC?.CAIS_Holder_ID_Details || []} convertDateForm={formatDate} /> */}
                            </div>
                          ))}
                        </div>
                      </td>
                    </tr>
                  )}

                </tbody>

              </table>






              <div className="bg-blue-900 hidden md:text-white text-white p-2 mt-2 rounded-tr-xl rounded-tl-xl text-sm">Account Summary</div>
              <div className="hidden gap-2 mt-2">

                {/* Primary Accounts Summary Card */}
                <div className="bg-gray-300 p-2 rounded-lg shadow-lg">
                  <h2 className="font-semibold text-sm mb-2 bg-blue-700 rounded-sm text-white text-center">Primary Accounts Summary</h2>
                  <div>
                    <p className='border-b'><span className="font-semibold">Number of Accounts:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-NUMBER-OF-ACCOUNTS"]}</p>
                    <p className='border-b'><span className="font-semibold">Active Accounts:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-ACTIVE-NUMBER-OF-ACCOUNTS"]}</p>
                    <p className='border-b'><span className="font-semibold">Overdue Accounts:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-OVERDUE-NUMBER-OF-ACCOUNTS"]}</p>
                    <p className='border-b'><spna className="font-semibold">Secured Accounts: </spna>{ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-SECURED-NUMBER-OF-ACCOUNTS"]}</p>
                    <p className='border-b'><spna className="font-semibold">Unsecured Accounts: </spna>{ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-UNSECURED-NUMBER-OF-ACCOUNTS"]}</p>
                    <p className='border-b'><span className="font-semibold">Current Balance:</span> ₹{ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-CURRENT-BALANCE"]}</p>
                    <p className='border-b'><span className="font-semibold">Sanctioned Amount:</span> ₹{ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-SANCTIONED-AMOUNT"]}</p>
                    <p className='border-b'><span className="font-semibold">Disbursed Amount:</span> ₹{ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-DISBURSED-AMOUNT"]}</p>
                  </div>
                </div>

                {/* Secondary Accounts Summary Card */}
                <div className="bg-gray-300  p-2 rounded-lg shadow-lg">
                  <h2 className="font-semibold text-sm mb-2 bg-blue-700 rounded-sm text-white text-center">Secondary Accounts Summary</h2>
                  <div>
                    <p className='border-b'><span className="font-semibold">Number of Accounts:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["SECONDARY-ACCOUNTS-SUMMARY"]?.["SECONDARY-NUMBER-OF-ACCOUNTS"]}</p>
                    <p className='border-b'><span className="font-semibold">Active Accounts:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["SECONDARY-ACCOUNTS-SUMMARY"]?.["SECONDARY-ACTIVE-NUMBER-OF-ACCOUNTS"]}</p>
                    <p className='border-b'><span className="font-semibold">Overdue Accounts:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["SECONDARY-ACCOUNTS-SUMMARY"]?.["SECONDARY-OVERDUE-NUMBER-OF-ACCOUNTS"]}</p>
                    <p className='border-b'><span className="font-semibold">Current Balance:</span> ₹{ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["SECONDARY-ACCOUNTS-SUMMARY"]?.["SECONDARY-CURRENT-BALANCE"]}</p>
                    <p className='border-b'><span className="font-semibold">Sanctioned Amount:</span> ₹{ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["SECONDARY-ACCOUNTS-SUMMARY"]?.["SECONDARY-SANCTIONED-AMOUNT"]}</p>
                    <p className='border-b'><span className="font-semibold">Disbursed Amount:</span> ₹{ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["SECONDARY-ACCOUNTS-SUMMARY"]?.["SECONDARY-DISBURSED-AMOUNT"]}</p>
                  </div>
                </div>

                {/* Derived Attributes Card */}
                <div className="bg-gray-300  p-2 rounded-lg shadow-lg">
                  <h2 className="font-semibold text-sm mb-2 bg-blue-700 rounded-sm text-white text-center">Derived Attributes</h2>
                  <div>
                    <p className='border-b'><span className="font-semibold">Inquiries in Last 6 Months:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["INQUIRIES-IN-LAST-SIX-MONTHS"]}</p>
                    <p className='border-b'><span className="font-semibold">Length of Credit History:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["LENGTH-OF-CREDIT-HISTORY-YEAR"]} Year, {ExperianReport?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["LENGTH-OF-CREDIT-HISTORY-MONTH"]} Month</p>
                    <p className='border-b'><span className="font-semibold">Average Account Age:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["AVERAGE-ACCOUNT-AGE-YEAR"]} Year, {ExperianReport?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["AVERAGE-ACCOUNT-AGE-MONTH"]} Month</p>
                    <p className='border-b'><span className="font-semibold">New Accounts in Last 6 Months:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["NEW-ACCOUNTS-IN-LAST-SIX-MONTHS"]}</p>
                    <p className='border-b'><span className="font-semibold">New Delinquent Accounts in Last 6 Months:</span> {ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["DERIVED-ATTRIBUTES"]?.["NEW-DELINQ-ACCOUNT-IN-LAST-SIX-MONTHS"]}</p>
                  </div>
                </div>
              </div>


              {/* Recent Activity Section */}
              <div className="  bg-blue-900 hidden md:text-white text-white p-2 mt-2 rounded-tr-xl rounded-tl-xl">Recent Activity (Last 90 Days)</div>
              <table className="min-w-full hidden table-auto border border-black text-left">
                <thead className="bg-gray-200">
                  <tr>
                    <th className="border border-black px-4 py-2">Total Inquiries</th>
                    <th className="border border-black px-4 py-2">InquiryPast30Days</th>
                    <th className="border border-black px-4 py-2">Inquiry Past 24Months</th>
                    <th className="border border-black px-4 py-2">Recent Inquiry date</th>
                  </tr>
                </thead>
                <tbody className="recentActivity">

                </tbody>
              </table>
            </div>



<div class="overflow-y-auto">
  <table class="min-w-full border border-gray-200 text-xs">
    <thead class="bg-gray-100 sticky top-0">
      <tr>
        <th class="border border-gray-200 px-2 py-1 text-left w-14">Code</th>
        <th class="border border-gray-200 px-2 py-1 text-left">Account Type</th>
        <th class="border border-gray-200 px-2 py-1 text-left w-14">Code</th>
        <th class="border border-gray-200 px-2 py-1 text-left">Account Type</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="border border-gray-100 px-1 py-0">01</td>
        <td class="border border-gray-100 px-1 py-0">Auto - Loan (Personal)</td>
        <td class="border border-gray-100 px-1 py-0">02</td>
        <td class="border border-gray-100 px-1 py-0">Housing Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">03</td>
        <td class="border border-gray-100 px-1 py-0">Property Loan</td>
        <td class="border border-gray-100 px-1 py-0">04</td>
        <td class="border border-gray-100 px-1 py-0">Loan Against Shares/Securities</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">05</td>
        <td class="border border-gray-100 px-1 py-0">Personal Loan</td>
        <td class="border border-gray-100 px-1 py-0">06</td>
        <td class="border border-gray-100 px-1 py-0">Consumer Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">07</td>
        <td class="border border-gray-100 px-1 py-0">Gold Loan</td>
        <td class="border border-gray-100 px-1 py-0">08</td>
        <td class="border border-gray-100 px-1 py-0">Education Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">09</td>
        <td class="border border-gray-100 px-1 py-0">Loan to Professional</td>
        <td class="border border-gray-100 px-1 py-0">10</td>
        <td class="border border-gray-100 px-1 py-0">Credit Card</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">11</td>
        <td class="border border-gray-100 px-1 py-0">Leasing</td>
        <td class="border border-gray-100 px-1 py-0">12</td>
        <td class="border border-gray-100 px-1 py-0">Overdraft</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">13</td>
        <td class="border border-gray-100 px-1 py-0">Two-Wheeler Loan</td>
        <td class="border border-gray-100 px-1 py-0">14</td>
        <td class="border border-gray-100 px-1 py-0">Non-Funded Credit Facility</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">15</td>
        <td class="border border-gray-100 px-1 py-0">Loan Against Bank Deposits</td>
        <td class="border border-gray-100 px-1 py-0">16</td>
        <td class="border border-gray-100 px-1 py-0">Fleet Card</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">17</td>
        <td class="border border-gray-100 px-1 py-0">Commercial Vehicle Loan</td>
        <td class="border border-gray-100 px-1 py-0">18</td>
        <td class="border border-gray-100 px-1 py-0">Telco – Wireless</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">19</td>
        <td class="border border-gray-100 px-1 py-0">Telco – Broadband</td>
        <td class="border border-gray-100 px-1 py-0">20</td>
        <td class="border border-gray-100 px-1 py-0">Telco – Landline</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">21</td>
        <td class="border border-gray-100 px-1 py-0">Seller Financing</td>
        <td class="border border-gray-100 px-1 py-0">23</td>
        <td class="border border-gray-100 px-1 py-0">GECL Loan Secured</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">24</td>
        <td class="border border-gray-100 px-1 py-0">GECL Loan Unsecured</td>
        <td class="border border-gray-100 px-1 py-0">31</td>
        <td class="border border-gray-100 px-1 py-0">Secured Credit Card</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">32</td>
        <td class="border border-gray-100 px-1 py-0">Used Car Loan</td>
        <td class="border border-gray-100 px-1 py-0">33</td>
        <td class="border border-gray-100 px-1 py-0">Construction Equipment Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">34</td>
        <td class="border border-gray-100 px-1 py-0">Tractor Loan</td>
        <td class="border border-gray-100 px-1 py-0">35</td>
        <td class="border border-gray-100 px-1 py-0">Corporate Credit Card</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">36</td>
        <td class="border border-gray-100 px-1 py-0">Kisan Credit Card</td>
        <td class="border border-gray-100 px-1 py-0">37</td>
        <td class="border border-gray-100 px-1 py-0">Loan on Credit Card</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">38</td>
        <td class="border border-gray-100 px-1 py-0">Prime Minister Jaan Dhan Yojana – Overdraft</td>
        <td class="border border-gray-100 px-1 py-0">39</td>
        <td class="border border-gray-100 px-1 py-0">Mudra Loans – Shishu/Kishor/Tarun</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">40</td>
        <td class="border border-gray-100 px-1 py-0">Microfinance – Business Loan</td>
        <td class="border border-gray-100 px-1 py-0">41</td>
        <td class="border border-gray-100 px-1 py-0">Microfinance – Personal Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">42</td>
        <td class="border border-gray-100 px-1 py-0">Microfinance – Housing Loan</td>
        <td class="border border-gray-100 px-1 py-0">43</td>
        <td class="border border-gray-100 px-1 py-0">Microfinance – Others</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">44</td>
        <td class="border border-gray-100 px-1 py-0">
          Pradhan Mantri Awas Yojana - Credit Link Subsidy Scheme MAY CLSS
        </td>
        <td class="border border-gray-100 px-1 py-0">45</td>
        <td class="border border-gray-100 px-1 py-0">P2P Personal Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">46</td>
        <td class="border border-gray-100 px-1 py-0">P2P Auto Loan</td>
        <td class="border border-gray-100 px-1 py-0">47</td>
        <td class="border border-gray-100 px-1 py-0">P2P Education Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">50</td>
        <td class="border border-gray-100 px-1 py-0">Business Loan – Secured</td>
        <td class="border border-gray-100 px-1 py-0">51</td>
        <td class="border border-gray-100 px-1 py-0">Business Loan – General</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">52</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Loan – Priority Sector – Small Business
        </td>
        <td class="border border-gray-100 px-1 py-0">53</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Loan – Priority Sector – Agriculture
        </td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">54</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Loan – Priority Sector – Others
        </td>
        <td class="border border-gray-100 px-1 py-0">55</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Non-Funded Credit Facility – General
        </td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">56</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Non-Funded Credit Facility – Priority Sector – Small Business
        </td>
        <td class="border border-gray-100 px-1 py-0">57</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Non-Funded Credit Facility – Priority Sector – Agriculture
        </td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">58</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Non-Funded Credit Facility – Priority Sector – Others
        </td>
        <td class="border border-gray-100 px-1 py-0">59</td>
        <td class="border border-gray-100 px-1 py-0">
          Business Loan Against Bank Deposits
        </td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">61</td>
        <td class="border border-gray-100 px-1 py-0">Business Loan – Unsecured</td>
        <td class="border border-gray-100 px-1 py-0">69</td>
        <td class="border border-gray-100 px-1 py-0">Short Term Personal Loan</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">70</td>
        <td class="border border-gray-100 px-1 py-0">Priority Sector- Gold Loan</td>
        <td class="border border-gray-100 px-1 py-0">71</td>
        <td class="border border-gray-100 px-1 py-0">Temporary Overdraft</td>
      </tr>
      <tr>
        <td class="border border-gray-100 px-1 py-0">00</td>
        <td class="border border-gray-100 px-1 py-0">Other</td>
        <td class="border border-gray-100 px-1 py-0"></td>
        <td class="border border-gray-100 px-1 py-0"></td>
      </tr>
    </tbody>
  </table>
</div>



    {/* Summary Section */}
        <div className="  bg-blue-900 md:text-white text-white p-2 mt-2 rounded-tr-xl rounded-tl-xl">Summary</div>
        <ul className="min-w-full table-auto border border-black text-left">

          {
            ExperianReport?.credit_report?.CAIS_Account?.CAIS_Summary?.Credit_Account &&
            Object.entries(ExperianReport?.credit_report?.CAIS_Account.CAIS_Summary?.Credit_Account).map(([key, value], i) => (
              <li key={i}>
                <span className="font-bold">{key || "N/A"}</span>: {value || "N/A"}
              </li>
            ))
          }
          {
            ExperianReport?.credit_report?.CAIS_Account?.CAIS_Summary?.Total_Outstanding_Balance &&
            Object.entries(ExperianReport?.credit_report?.CAIS_Account.CAIS_Summary?.Total_Outstanding_Balance).map(([key, value], i) => (
              <li key={i}>
                <span className="font-bold">{key || "N/A"}</span>: {value || "N/A"}
              </li>
            ))
          }
        </ul>
        <table className="min-w-full hidden table-auto border border-black text-left">
          <thead className="bg-gray-200">
            <tr className='text-xs'>
              <th className="border border-black px-2 py-1">Number of Open Accounts</th>
              <th className="border border-black px-2 py-1">Total Past Due Amount</th>
              <th className="border border-black px-2 py-1">ZeroBalance Account</th>
            </tr>
          </thead>
          <tbody class="summary2">

          </tbody>
        </table>

        <table className="min-w-full hidden table-auto border border-black text-left">
          <thead className="bg-gray-200">
            <tr className='text-xs'>
              <th className="border border-black px-2 py-1">Total High Credit</th>
              <th className="border border-black px-2 py-1">Total Sanction Amount</th>
              <th className="border border-black px-2 py-1">Single Highest Sanction</th>
            </tr>
          </thead>
          <tbody class="summary2">
            <tr className='text-xs'>
              <td className='border border-black px-2 py-1'>{ExperianReport?.[""]}</td>
              <td className='border border-black px-2 py-1'>{ExperianReport?.["INDV-REPORTS"]?.["INDV-REPORT"]?.["ACCOUNTS-SUMMARY"]?.["PRIMARY-ACCOUNTS-SUMMARY"]?.["PRIMARY-SANCTIONED-AMOUNT"]}</td>
              <td className='border border-black px-2 py-1'>{ExperianReport?.[""]}</td>
            </tr>
          </tbody>
        </table>

          </>

        </div>
      </>

    </>
  )
}




const PaymentHistoryLists = ({ history }) => {
  if (!history || !Array.isArray(history) || history.length === 0) {
    return <p className="text-sm text-gray-500">No Payment History Available</p>;
  }

  const monthNames = [
    "", "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  // Legend
  const legend = [
    { label: "Standard (S)", color: "bg-green-500" },
    { label: "Default (D)", color: "bg-red-500" },
    { label: "Past Due (P)", color: "bg-yellow-400" },
    { label: "Special (X)", color: "bg-blue-500" },
     { label: "N/A", color: "bg-gray-400" }
  ];

  return (
    <div className="w-full mb-1 border rounded p-1">
      <p className="font-bold mb-2 text-sm">Payment History</p>

      <div className="grid grid-cols-12 gap-1">
        {history.map((item, idx) => {
          const classification = item.Asset_Classification;
          const monthYear = `${monthNames[item.Month] || ""} ${item.Year || ""}`;


          let circleColor = "bg-gray-400";
          let statusText = "N/A";

          switch (classification) {
            case "S": circleColor = "bg-green-500"; statusText = "000"; break;
            case "D": circleColor = "bg-red-500"; statusText = "D"; break;
            case "P": circleColor = "bg-yellow-400"; statusText = "P"; break;
            case "X": circleColor = "bg-blue-500"; statusText = "X"; break;
            default: circleColor = "bg-gray-400"; statusText = "-";
          }

          return (
            <div
              key={idx}
              className="flex flex-col items-center justify-center border rounded-md p-1"
            >
              <div
                className={`w-4 h-4 flex items-center justify-center rounded-full text-white text-xs ${circleColor}`}
              >
                {/* {statusText} */}
              </div>
              <span className="text-xs mt-1 text-center">{monthYear}</span>
            </div>
          );
        })}
      </div>

      {/* Legend */}
      <div className="flex flex-wrap gap-1 text-xs text-gray-700 mt-1">
        {legend.map((item, i) => (
          <div key={i} className="flex items-center gap-1">
            <div className={`w-3 h-3 rounded-full ${item.color}`}></div>
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};


const AccountHolderDetails = ({ accountHolder, convertDateForm }) => {
  if (!accountHolder || !Array.isArray(accountHolder) || accountHolder.length === 0) {
    return null;
  }

  return (
    <div className='w-full mb-4'>
      <p className='font-semibold bg-blue-900 text-white p-2 rounded-tr-xl rounded-tl-xl text-xs'>Account Holder Details</p>
      <table className='w-full border border-collapse'>
        <thead className='bg-blue-900'>
          <tr className='text-xs'>
            <th className="border px-2 py-1 text-white">SN.</th>
            <th className="border px-2 py-1 text-white">Name</th>
            <th className="border px-2 py-1 text-white">PAN</th>
            <th className="border px-2 py-1 text-white">DOB</th>
          </tr>
        </thead>
        <tbody>
          {accountHolder.map((item, idx) => (
            <tr key={idx} className="border text-xs">
              <td className="border px-2 py-1">{idx + 1}</td>
              <td className="border px-2 py-1">
                {`${item.Surname_Non_Normalized || ''} ${item.First_Name_Non_Normalized || ''} ${item?.Middle_Name_1_Non_Normalized || ''}`.trim()}
              </td>
              <td className="border px-2 py-1">{item?.Income_TAX_PAN || "N/A"}</td>
              <td className="border px-2 py-1">{convertDateForm ? convertDateForm(item.Date_of_birth) : item.Date_of_birth || "N/A"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const AccountHolderPhoneDetails = ({ phoneDetails, convertDateForm }) => {
  if (!phoneDetails || !Array.isArray(phoneDetails) || phoneDetails.length === 0) {
    return null;
  }

  return (
    <div className='w-full mb-4'>
      <p className='font-semibold bg-blue-900 text-white p-2 rounded-tr-xl rounded-tl-xl text-sm'>Account Holder Phone Details</p>
      <table className='w-full border border-collapse'>
        <thead className='bg-blue-900'>
          <tr className='text-xs'>
            <th className="border px-2 py-1 text-white">SN.</th>
            <th className="border px-2 py-1 text-white">Mobile</th>
            <th className="border px-2 py-1 text-white">Fax</th>
            <th className="border px-2 py-1 text-white">Email</th>
          </tr>
        </thead>
        <tbody>
          {phoneDetails.map((item, idx) => (
            <tr key={idx} className="border">
              <td className="border px-2 py-1">{idx + 1}</td>
              <td className="border px-2 py-1">{item.Mobile_Telephone_Number || "N/A"}</td>
              <td className="border px-2 py-1">{item?.Fax_Number || "N/A"}</td>
              <td className="border px-2 py-1">{item?.EMailId || "N/A"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const AccountHolderIdDetails = ({ idDetails }) => {
  if (!idDetails || Object.keys(idDetails).length === 0) {
    return null;
  }

  return (
      <p className="p-2 text-sm">
        <span className="font-semibold">Id :</span> {idDetails?.Income_TAX_PAN || "N/A"}
      </p>

  );
};


const AccountHolderAddressDetails = ({ addressDetails }) => {
  return (
    <>
      {addressDetails?.length > 0 && (
        <div className="w-full">
          <h3 className="font-semibold bg-blue-800 text-white p-2 rounded-t">
            Address
          </h3>
          <table className="table w-full border text-sm">
            <thead className="bg-gray-200 border">
              <tr>
                <th className="border px-2 py-1">Sn</th>
                <th className="border px-2 py-1">Address</th>
              </tr>
            </thead>
            <tbody>
              {addressDetails.map((item, idx) => (
                <tr key={idx} className="border">
                  <td className="border px-2 py-1 font-semibold">
                    Address: {idx + 1}
                  </td>
                  <td className="border px-2 py-1">
                    {[
                      item?.First_Line_Of_Address_non_normalized,
                      item?.Second_Line_Of_Address_non_normalized,
                      item?.Third_Line_Of_Address_non_normalized,
                      item?.City_non_normalized,
                      item?.State_non_normalized,
                      item?.PinCode,
                    ]
                      .filter(Boolean)
                      .join(" ")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default ExperianScore
